import ResizeObserverPolyfill from 'resize-observer-polyfill';
const mobileBreakpoint = 680;
const PageResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
function getProducts(guidanceList) {
  return Array.from(guidanceList.children).filter(item => item.classList.contains('product-thumbnail'));
}
function getActualColumnsFromProducts(products) {
  if (products.length === 0) return 0;
  const columnPositions = [];
  const positionTolerance = 5;
  products.forEach(product => {
    const productRect = product.getBoundingClientRect();
    if (productRect.width === 0 || productRect.height === 0) return;
    const knownColumn = columnPositions.some(position => Math.abs(position - productRect.left) <= positionTolerance);
    if (!knownColumn) columnPositions.push(productRect.left);
  });
  return columnPositions.length;
}
function getComputedColumns(guidanceList) {
  const gridTemplateColumns = window.getComputedStyle(guidanceList).gridTemplateColumns.trim();
  if (!gridTemplateColumns || gridTemplateColumns === 'none') return 0;
  return gridTemplateColumns.split(/\s+/).length;
}
function productsOffsetInPlp(guidanceList, products) {
  if (window.innerWidth < mobileBreakpoint) return 4;
  guidanceList.offsetHeight;
  const actualColumns = getActualColumnsFromProducts(products);
  const computedColumns = getComputedColumns(guidanceList);
  if (actualColumns === products.length && computedColumns > actualColumns) {
    return computedColumns;
  }
  return actualColumns || computedColumns;
}
function getBannerPlacement(guidanceList) {
  const products = getProducts(guidanceList);
  const offsetList = productsOffsetInPlp(guidanceList, products);
  const insertionTarget = products[offsetList - 2];
  if (offsetList === 0 || products.length === 0 || offsetList > products.length || !insertionTarget) return null;
  return {
    insertionTarget,
    offsetList,
    firstProduct: products[0],
    productHeight: products[0].offsetHeight
  };
}
function setInlineStyle(element, property, value) {
  if (element.style.getPropertyValue(property) !== value) element.style.setProperty(property, value);
}
function applyBannerLayout(categoryBanner, placement) {
  if (window.innerWidth >= mobileBreakpoint) {
    categoryBanner.style.removeProperty('height');
    setInlineStyle(categoryBanner, 'grid-column', placement.offsetList.toString());
  } else {
    setInlineStyle(categoryBanner, 'grid-column', '');
  }
}
function isBannerInFirstProductRow(categoryBanner, placement) {
  if (window.innerWidth < mobileBreakpoint) return false;
  const firstProductRect = placement.firstProduct.getBoundingClientRect();
  const bannerRect = categoryBanner.getBoundingClientRect();
  if (firstProductRect.height === 0 || bannerRect.height === 0) return false;
  const tolerance = Math.max(15, firstProductRect.height * 0.15);
  return Math.abs(bannerRect.top - firstProductRect.top) <= tolerance;
}
function positionCategBannerFragmentsInProductsList() {
  const categoryBanner = document.getElementById('component-arm-category-banner');
  if (!categoryBanner) return;
  let guidanceList = document.getElementById("guidance-product-list");
  if (!guidanceList) return;
  let placement = getBannerPlacement(guidanceList);
  const isAlreadyPlaced = placement && (placement.insertionTarget.nextElementSibling === categoryBanner || isBannerInFirstProductRow(categoryBanner, placement));
  if (isAlreadyPlaced) {
    applyBannerLayout(categoryBanner, placement);
    setInlineStyle(categoryBanner, 'display', 'block');
    return;
  }
  setInlineStyle(categoryBanner, 'display', 'none');
  categoryBanner.style.removeProperty('grid-column');

  // Hiding the banner can change the measured grid columns, so calculate the
  // target again before moving it.
  placement = getBannerPlacement(guidanceList);
  if (!placement) {
    setInlineStyle(categoryBanner, 'display', 'none');
    categoryBanner.style.gridColumn = '';
    categoryBanner.style.height = '';
    return;
  }
  applyBannerLayout(categoryBanner, placement);
  if (placement.insertionTarget.nextElementSibling !== categoryBanner) placement.insertionTarget.after(categoryBanner);
  setInlineStyle(categoryBanner, 'display', 'block');
}
lm.DOMReady(() => {
  let scheduledPositioning = null;
  const schedulePositioning = () => {
    if (scheduledPositioning) cancelAnimationFrame(scheduledPositioning);
    scheduledPositioning = requestAnimationFrame(() => {
      scheduledPositioning = requestAnimationFrame(() => {
        scheduledPositioning = null;
        positionCategBannerFragmentsInProductsList();
      });
    });
  };
  ['resize', 'guidance:dom:updated'].forEach(event => window.addEventListener(event, schedulePositioning));
  const isRelevantLayoutNode = node => node.nodeType === 1 && (node.classList.contains('product-thumbnail') || node.classList.contains('l-resultsList__breakzone') || node.classList.contains('search_editorials-container') || node.classList.contains('push-collection-line-digital-endcap-container') || node.classList.contains('push-digital-endcap-container') || node.classList.contains('push-highlight-digital-endcap-container'));
  const observer = new MutationObserver(mutationsList => {
    const hasLayoutChange = mutationsList.some(mutation => {
      const changedNodes = [...Array.from(mutation.addedNodes), ...Array.from(mutation.removedNodes)];
      return changedNodes.some(isRelevantLayoutNode);
    });
    if (!hasLayoutChange) return;
    schedulePositioning();
  });
  const targetNode = document.getElementById("guidance-product-list");
  if (targetNode) {
    observer.observe(targetNode, {
      childList: true,
      subtree: false
    });
    let observedWidth = Math.round(targetNode.getBoundingClientRect().width);
    const resizeObserver = new PageResizeObserver(entries => {
      const width = Math.round(entries[0].contentRect.width);
      if (width === observedWidth) return;
      observedWidth = width;
      schedulePositioning();
    });
    resizeObserver.observe(targetNode);
  }
  schedulePositioning();
  const buttonsModal = document.querySelectorAll('.arm-navigation-open-modal');
  if (buttonsModal) {
    buttonsModal.forEach(b => b.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const io = b.getAttribute('data-io');
      document.dispatchEvent(new CustomEvent("arm-popin-dsa-open", {
        detail: io
      }));
    }));
  }
});